'use client';
import { cn } from '@/lib/utils';

import Button from '@/components/atoms/Button';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { getIntlText } from '@/lib/i18n/i18n.server';

type MenuCarouselPaginationProps = {
  itemCount: number;
  activeIndex: number;
  handlePageChange: (index: number) => void;
};

export function MenuCarouselPagination({
  itemCount,
  activeIndex,
  handlePageChange,
}: MenuCarouselPaginationProps) {
  const { texts } = useTranslation();
  return (
    <ul
      className='relative mt-3 flex gap-x-2'
      role='group'
      aria-label='Carousel pagination'
    >
      {Array.from(Array(itemCount).keys()).map((_, i) => (
        <li key={i} className='leading-[0]'>
          <Button
            noStyles
            onClick={() => handlePageChange(i)}
            className={cn(
              'bg-gray-dark-950  relative h-2 w-2 outline-none duration-300 after:absolute after:-inset-1.5 focus-visible:ring-1 focus-visible:ring-gray-400 focus-visible:ring-offset-2',
              activeIndex !== i &&
                'bg-gray-dark-200 hover-hover:hover:bg-gray-dark-400 z-[1]'
            )}
          >
            <span className='sr-only'>
              {getIntlText(texts.menu_carousel_pagination.slide_index, {
                index: String(i + 1),
              })}
              {activeIndex === i &&
                `(${texts.menu_carousel_pagination.current_item_text})`}
            </span>
          </Button>
        </li>
      ))}
      <div className='sr-only' aria-live='polite' aria-atomic='true'>
        {getIntlText(texts.menu_carousel_pagination.slide_index_of_total, {
          index: String(activeIndex + 1),
          total: String(itemCount),
        })}
      </div>
    </ul>
  );
}
